<template>
  <div class="manageUser">
    <!-- <div class="header">
      <van-nav-bar
        title="用户管理"
        left-text="返回"
        left-arrow
        @click-left="goBack"
      /> -->
      <div class="content">
      <div class="search">
        <van-search
          v-model="value"
          show-action
          placeholder="请输入搜索用户名"
          @search="onSearch"
          @input="onSearch"
        >
          <template #action>
            <div @click="onSearch(value)">搜索</div>
          </template>
        </van-search>
        <span style="color: #fa8f04;font-weight: bold; font-size: 13px;
        float: right;margin-right: 6%;">{{ queryDataLength }}</span>
        <van-divider />
      </div>

        <!-- 添加 -->
        <div class="addUser add-contact-card" role="button" tabindex="0" @click="onAdd">
          <van-icon name="add" class="van-add__left-icon"/>
          <div class="add-value add-value__alone">添加管理员</div>
          <van-icon name="arrow" class="van-add__right-icon"/>
        </div>

        <!-- 查询到的用户列表 -->
        <div class="addUser add-contact-card" role="button" tabindex="0" @click="onEdit(item)" 
          v-for="item in responseDataArray" :key="item.id">
        <van-icon name="user" class="user__left-icon"/>
        <div class="add-value add-value__alone"  >用户名：{{ item.userName }}</div>
        <van-button @click.stop="onDelete(item)">删除</van-button>
        </div>
      </div>
      <!-- 编辑 -->
      <van-overlay :show="exitShow" @click="exitShow=false">
        <div class="manageWrapper" @click.stop>
          <div class="manageBlock">
            <van-form ref="exitForm">
              <div class="title">
              <span>编辑</span>
            </div>
              <van-field label="姓名：" v-model="showList.name"/>
              <van-field label="用户名：" v-model="showList.userName" disabled/>
              <van-field label="密码：" v-model="showList.password" :type="exitPasswordType">
                <template slot="right-icon">
                  <span class="slots" @click="switchPasswordType('exit')" >
                    <van-icon name="browsing-history-o" v-if="exitPasswordType === 'text'" />
                    <van-icon name="closed-eye" v-else color="black"/>
                  </span>
                </template>
              </van-field>
              <!-- <van-field label="手机号：" v-model="showList.phone"/> -->
              <van-field label="创建时间： " v-model="showList.createTime" disabled>{{ showList.createTime | formatTime }}</van-field>
              <van-field label="类型： " :disabled="manageTypeDisabled">
                <template #input>
                  <van-radio-group v-model="showList.role" :disabled="manageTypeDisabled">
                    <van-radio :name= 0 checked-color="#3399ff">超级管理员</van-radio>
                    <van-radio :name= 1 checked-color="#3399ff">管理员</van-radio>
                    <van-radio :name= 2 checked-color="#3399ff">职员</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
              <van-field label="状态： "  :disabled="manageTypeDisabled">
                <template #input>
                  <van-radio-group v-model="showList.state" direction="horizontal" :disabled="manageTypeDisabled">
                    <van-radio :name= 0 checked-color="#3399ff">正常</van-radio>
                    <van-radio :name= 1 checked-color="#3399ff">禁用</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
            </van-form>
            <div style="margin: 16px;">
              <van-row style="margin-top: 2%;">
                <van-col :span="12">
                  <van-button @click="cancel" plain hairline type="info" class="buttons">取消</van-button>
                </van-col>
                <van-col :span="12">
                  <van-button @click="confirm" plain hairline type="info" class="buttons">确认</van-button>
                </van-col>
              </van-row>
            </div>
          </div>
        </div>
      </van-overlay>
      <!-- 新增 -->
      <van-overlay :show="addShow" @click="addShow=false">
        <div class="manageWrapper" @click.stop>
          <div class="manageBlock">
          <van-form ref="addForm">
            <div class="title">
              <span>添加管理员</span>
            </div>
            <van-field label="姓名：" v-model="addUserForm.name" placeholder="姓名"
            :rules="[{required:true,message:'请输入姓名'}]"/>
            <van-field label="用户名：" v-model="addUserForm.userName" placeholder="用户名"
            :rules="[{required:true,message:'请输入用户名'}]"/>
            <van-field label="密码：" v-model="addUserForm.password" placeholder="密码" :type="passwordType"
            :rules="[{required:true,message:'请输入密码'}]">
              <template slot="right-icon">
                <span class="slots" @click="switchPasswordType('add')" >
                  <van-icon name="browsing-history-o" v-if="passwordType === 'text'" />
                  <van-icon name="closed-eye" v-else color="black"/>
                </span>
            </template>
            </van-field>
            <van-field label="手机号：" 
              v-model="addUserForm.phoneNo" 
              placeholder="手机号" 
              type="tel"
              maxlength="11"
              :rules="[{required:true,pattern:/^1[3456789]\d{9}$/,message:'请输入手机号码'}]"
              />
            <van-field label="类型： " v-model="addUserForm.verifyCode" >
              <template #input>
                <van-radio-group v-model="addUserForm.role">
                  <van-radio :name= 0 checked-color="#3399ff">超级管理员</van-radio>
                  <van-radio :name= 1 checked-color="#3399ff">管理员</van-radio>
                  <van-radio :name= 2 checked-color="#3399ff">职员</van-radio>
                </van-radio-group>
              </template>
            </van-field>
            <van-field label="状态： " >
              <template #input>
                <van-radio-group v-model="addUserForm.state" direction="horizontal">
                  <van-radio :name= 0 checked-color="#3399ff">正常</van-radio>
                  <van-radio :name= 1 checked-color="#3399ff">禁用</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </van-form>
            <div style="margin: 16px;">
                <van-row style="margin-top: 2%;">
                  <van-col :span="12">
                    <van-button @click="addCancel" plain hairline type="info" class="buttons">取消</van-button>
                  </van-col>
                  <van-col :span="12">
                    <van-button @click="addConfirm" plain hairline type="info" class="buttons">确认</van-button>
                  </van-col>
                </van-row>
            </div>
        
          </div>
        </div>
      </van-overlay>
    </div>
</template>

<script>
import {QueryUser,ModifyUser,AddUser,DeleteUser} from '@/my_js/HttpRequest.js'
import {formatTime} from '@/utils/date.js'
import { Dialog } from 'vant'
import { Notify } from 'vant'
import md5 from 'js-md5'
import store from '../../store/index'
export default {
  mounted(){
    this.onSearch()
  },
  components:{

  },
  filters:{
    formatTime:function(inputTime){
     return formatTime(inputTime)
    },
    formatType:function(inputValue){
      if(inputValue == 0){
        return '超级管理员'
      }else if (inputValue == 1){
        return '管理员'
      }else if (inputValue == 2){
        return '职员'
      }
    },
    formatState:function(inputState){
      if(inputState == 0){
        return '正常'
      }else if (inputState == 1){
        return '禁用'
      }
    }
  },
  data(){
    return{
      exitPasswordType:'password',//密码框输入类型
      passwordType:'password',//密码框输入类型
      value:'',//搜索内容
      responseDataArray:[],//响应数据
      exitShow:false,//编辑显示
      showList:[],//编辑展示的数据
      exitData:[],//编辑后的数据
      addUserForm:{
        name:'',//用户姓名
        userName:'',//用户名
        password: '',//密码
        phoneNo: '',//手机号
        state: 0,//状态
        role: 0,//角色类型 超级管理员、管理员、职员
      },
      addShow:false,//添加用户
      manageTypeDisabled:false,//管理员类型禁用
      queryDataLength:null,//查询到的数据量
      
    }
  },
  methods:{
    // 返回
    goBack(){
      console.log('返回管理员首页');
      this.$router.push('/manager')
    },
    // 查询用户
    onSearch(val){
      console.log(val);
      // const data = {
      //   userName: this.value,
      // }
      // QueryUser(data).then(res => {
      //   console.log('查询用户res',res);
      //   this.responseDataArray = res.data
      // })
      if( store.state.role == 0){
        const data = {
          userName: this.value,
        }
        QueryUser(data).then(res => {
          console.log('查询用户res',res);
          this.responseDataArray = res.data
          this.queryDataLength = this.responseDataArray.length
        })
      }else{
        console.log(store.state.userName);
        QueryUser({userName:store.state.userName}).then(res => {
          console.log('查询用户res',res);
          this.responseDataArray = res.data
          this.queryDataLength = this.responseDataArray.length
        })
      }
    },
    // 添加用户
    onAdd(){
      console.log('添加用户');
      // this.addShow = true
      if(store.state.role == 0){
        this.addShow = true
      }else{
        Notify({type:'warning',message:'当前账号没有该操作权限'})
      }
    },
    addConfirm(){
      console.log(this.addUserForm);
      this.$refs.addForm.validate()
      .then(valid => {
          // 表单验证成功
          console.log('验证通过');
          const psd = md5(this.trimmedStr(this.addUserForm.password)).toUpperCase()
          const addManageArray = {
            name:this.addUserForm.name,//用户姓名
            userName:this.addUserForm.userName,//用户名
            password: psd,//密码
            phoneNo: this.addUserForm.phoneNo,//手机号
            state: this.addUserForm.state,//状态
            role: this.addUserForm.role,//角色类型 超级管理员、管理员、职员
          }
          AddUser(addManageArray).then(res =>{
          console.log('添加用户res',res);
          this.addShow = false
          this.addUserForm={
          name:'',//用户姓名
          userName:'',//用户名
          password: '',//密码
          phoneNo: '',//手机号
          state: 0,//状态
          role: 0,//角色类型 超级管理员、管理员、职员
          },
          Notify({type:'success',message:'添加'+res.msg})
          this.onSearch()
        })
      })
      .catch(error => {
        console.log('验证不通过');
        console.log('Validation failed:',error);
      })
    },
    // 取消添加用户
    addCancel(){
      console.log('取消添加用户');
      this.addShow = false
      this.addUserForm={
        name:'',//用户名
        userName:'',//账号
        password: '',//密码
        phoneNo: '',//手机号
        state: 0,//状态
        role: 0,//角色类型 超级管理员、管理员、职员
        }
        this.passwordType = 'password'
    },
    // 编辑
    onEdit(val){
      console.log('编辑用户');
      console.log(val);
      this.showList = val
      this.exitData = val
      this.showList.createTime = formatTime(this.showList.createTime)
      if(store.state.role !== 0){
        this.manageTypeDisabled = true
      }
      this.exitShow = true
      console.log('修改前数据：',this.showList);
    },
     // 提交修改表单
    //  confirm(){
    //   Dialog.confirm({
    //     title:'消息确认',
    //     message:`是否确定修改该用户的信息？`
    //   }).then(()=>{
    //     // 修改请求
    //     console.log('点击了确定修改');
    //     const psd = md5(this.trimmedStr(this.showList.password)).toUpperCase()
    //     this.exitData.password = psd
    //     console.log('修改后数据：',this.exitData);
    //     ModifyUser(this.showList).then(res => {
    //       console.log('修改res:',res);
    //       this.exitShow = false
    //       Notify({type:'success',message:'修改'+res.msg})
    //     })
    //     this.onSearch()
    //   }).catch(error =>{
    //     console.log(error);
    //   })
    // },
    confirm(){
      Dialog.confirm({
        title: '消息确认',
        message: `是否确定修改该用户的信息？`,
        // confirmButtonColor: 'red', // 修改确认按钮的背景颜色
      }).then(() => {
        // 修改请求
        console.log('点击了确定修改');
        const psd = md5(this.trimmedStr(this.showList.password)).toUpperCase()
        this.exitData.password = psd
        console.log('修改后数据：', this.exitData);

        ModifyUser(this.showList).then(res => {
          console.log('修改res:', res);
          this.exitShow = false;
          Notify({ type: 'success', message: '修改' + res.msg });
        });
        this.onSearch();
      }).catch(error => {
        console.log(error);
      });

    },
    // 取消修改
    cancel(){
        console.log('点击了取消修改');
        this.exitShow = false
        this.onSearch()
        this.exitPasswordType = 'password'
      },
    // 删除用户
    onDelete(val){
      console.log('删除用户');
      if(store.state.userName === val.userName){
       Notify({type:'warning',message:'不能删除当前登录用户'})
      }else{
        Dialog.confirm({
          title:'提示',
          message:`确认删除 ${val.userName} ？`
        }).then(()=>{
          // 确认删除用户
          DeleteUser(val).then(res =>{
          console.log('删除用户',res);
          Notify({type:'success',message:'删除'+res.msg})
          this.onSearch()
        })
        }).catch(error=>{
          console.log(error);
        })
      }
    },
    // 密码图标切换
    switchPasswordType(val){
      console.log(val);
      if(val == 'add'){
        this.passwordType = this.passwordType === 'password'?'text':'password'
      }else if(val == 'exit'){
        this.exitPasswordType = this.exitPasswordType === 'password'?'text':'password'
      }
      // this.passwordType = this.passwordType === 'password'?'text':'password'
    },
    // 去除空格
    trimmedStr(str){
      return str.replace(/\s+/g,'')
    },
   
  }

}
</script>

<style lang="scss" >
.manageUser{
  .van-nav-bar__left{
    left: 0;
  }
  .van-nav-bar .van-icon{
    color: #0283ef;
  }
  .van-nav-bar__text{
    color: #0283ef;
  }
  .van-search__action{
    color: #0283ef;
    font-size: 18px;
  }
  .addUser {
  position: relative;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
  color: #111;
  font-size: 25px;
  line-height: 50px;
  background-color: #fff;
  .user__left-icon{
  line-height: 50px;
  font-size: 22px;
  color: #0283ef;
}
}

.addUser::before {
  position: absolute;
  right: 0;
  left: 0;
  bottom: 0;
  height: 1px;
  // background: repeating-linear-gradient(-45deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #0283ef 0, #0283ef 45%, transparent 0, transparent 50%);
  // background-size: 95px;
  background: repeating-linear-gradient(-180deg, #f0efef 0, #f0efef 20%, 
  transparent 0, transparent 25%, #f0efef 0, #f0efef 45%, transparent 0, transparent 50%);
  background-size: 150px;
  content: '';
}

.add-user-clickable {
  cursor: pointer;
}

.add-user-center {
  display: flex;
  align-items: center;
}
.add-value{
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-box-flex: 5;
  flex: 5;
}
.add-value__alone{
  color: #333;
  text-align: left;
  font-size: 16px;
  margin-left: 8px;
}

.add-contact-card {
  padding: 10px;
}

.van-add__left-icon {
  color: #0283ef;
  font-size: 35px;
}
.van-radio{
  padding-bottom:3px ;
}
.van-add__right-icon{
  margin-left: 10px;
  font-size: 18px;
  color: #999;
}

.van-add__left-icon, .van-add__right-icon {
  min-width: 30px;
  height: 50px;
  line-height: 50px;
}

.manageWrapper{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .manageBlock{
    width: 90%;
    // height: 76%;
    border-radius: 8px;
    background-color: #fff;
    .title{
    margin-top: 3%;
    }

    .van-cell__value{
      text-align: left;
    }
    .buttons{
      width: 90%;
    }
  }
  }
}
.van-dialog__confirm {
  background-color: #0094ff; /* 确认按钮背景色 */
  color: #fff; /* 确认按钮字体颜色 */
}
</style>